export default __webpack_public_path__ + "static/media/listing-photo.70abbdc2.svg";